// import React, { useEffect, useState } from "react";
// import a17logo from "./logg.png"

// const LandingScreen = () => {
//     const [visible, setVisible] = useState(false);

//     useEffect(() => {
//         setTimeout(() => setVisible(true), 300);
//     }, []);

//     return (
//         <div
//             style={{
//                 height: "100vh",
//                 width: "100%",
//                 background: "#1f2a2e",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "white",
//                 fontFamily: "Montserrat, sans-serif",
//                 overflow: "hidden",
//                 position: "relative",
//             }}
//         >
//             {/* Background Texture */}
//             <div
//                 style={{
//                     position: "absolute",
//                     width: "100%",
//                     height: "100%",
//                     backgroundImage:
//                         "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.05), transparent 40%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.05), transparent 40%)",
//                     opacity: 0.4,
//                 }}
//             />

//             {/* Logo */}
//             <div
//                 style={{
//                     marginBottom: "20px",
//                     transform: visible ? "translateY(0px)" : "translateY(-40px)",
//                     opacity: visible ? 1 : 0,
//                     transition: "all 0.8s ease",
//                 }}
//             >
//                 <div
//                     style={{
//                         width: "60px",
//                         height: "60px",
//                         borderTop: "8px solid #d9d9d9",
//                         borderRight: "8px solid transparent",
//                         transform: "rotate(45deg)",
//                         position: "relative",
//                     }}
//                 >
//                     <div
//                         style={{
//                             position: "absolute",
//                             top: "20px",
//                             left: "10px",
//                             width: "30px",
//                             height: "8px",
//                             background: "#5bc0eb",
//                             transform: "rotate(-45deg)",
//                         }}
//                     />
//                 </div>
//             </div>

//             {/* ULTRA PURIFIED */}
//             <h3
//                 style={{
//                     letterSpacing: "3px",
//                     color: "#5bc0eb",
//                     margin: 0,
//                     fontWeight: "500",
//                     opacity: visible ? 1 : 0,
//                     transition: "opacity 1s ease 0.5s",
//                 }}
//             >
//                 ULTRA-PURIFIED
//             </h3>

//             {/* A17 Title */}
//             <h1
//                 style={{
//                     fontSize: "80px",
//                     margin: "10px 0",
//                     fontWeight: "900",
//                     background:
//                         "linear-gradient(180deg, #ffffff 0%, #bfbfbf 50%, #7f7f7f 100%)",
//                     WebkitBackgroundClip: "text",
//                     WebkitTextFillColor: "transparent",
//                     letterSpacing: "5px",
//                     opacity: visible ? 1 : 0,
//                     transform: visible ? "scale(1)" : "scale(0.8)",
//                     transition: "all 0.8s ease 0.6s",
//                 }}
//             >
//                 <img src={a17logo} alt="logo" style={{ height: 60 }} />
//             </h1>

//             {/* Premium Hydro Cell */}
//             <h2
//                 style={{
//                     color: "#5bc0eb",
//                     letterSpacing: "2px",
//                     margin: "5px 0",
//                     opacity: visible ? 1 : 0,
//                     transition: "opacity 1s ease 0.8s",
//                 }}
//             >
//                 PREMIUM HYDRO CELL
//             </h2>

//             {/* Subtitle */}
//             <p
//                 style={{
//                     color: "#cfd8dc",
//                     letterSpacing: "1px",
//                     fontSize: "14px",
//                     opacity: visible ? 1 : 0,
//                     transition: "opacity 1s ease 1s",
//                 }}
//             >
//                 MOLECULARLY FILTERED WATER
//             </p>

//             {/* Animated Wave Line */}
//             <div
//                 style={{
//                     width: "250px",
//                     height: "2px",
//                     background: "#5bc0eb",
//                     marginTop: "30px",
//                     position: "relative",
//                     overflow: "hidden",
//                 }}
//             >
//                 <div
//                     style={{
//                         position: "absolute",
//                         width: "50px",
//                         height: "2px",
//                         background: "#5bc0eb",
//                         animation: "wave 1.5s infinite linear",
//                     }}
//                 />
//             </div>

//             {/* Inline Keyframes */}
//             <style>
//                 {`
//           @keyframes wave {
//             0% { left: -50px; }
//             100% { left: 100%; }
//           }
//         `}
//             </style>

//             {/* Footer Text */}
//             <p
//                 style={{
//                     marginTop: "40px",
//                     fontSize: "12px",
//                     color: "#aaa",
//                     opacity: visible ? 1 : 0,
//                     transition: "opacity 1s ease 1.2s",
//                 }}
//             >
//                 Crush the bottle after use
//             </p>
//         </div>
//     );
// };

// export default LandingScreen;


// import React, { useEffect, useState } from "react";
// import a17logo from "./A17 ULTRA-PURIFIED.png";

// const LabelDesign = () => {
//     const [show, setShow] = useState(false);
//     const [isMobile, setIsMobile] = useState(false);

//     useEffect(() => {
//         setTimeout(() => setShow(true), 200);

//         const handleResize = () => setIsMobile(window.innerWidth < 768);
//         handleResize();
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     const styles = {
//         wrapper: {
//             minHeight: "100vh",
//             width: "100%",
//             background: "#2c3437",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             fontFamily: "'Montserrat', sans-serif",
//             color: "white",
//             position: "relative",
//             overflow: "hidden",
//             padding: "40px 20px",
//             boxSizing: "border-box",
//         },
//         bgTexture: {
//             position: "absolute",
//             inset: 0,
//             backgroundColor: "#2c3437",
//             backgroundImage: "url('https://www.transparenttextures.com/patterns/cartographer.png')",
//             backgroundRepeat: "repeat",
//             backgroundBlendMode: "multiply",
//             zIndex: 1,
//         },
//         container: {
//             textAlign: "center",
//             zIndex: 2,
//             transform: show ? "translateY(0)" : "translateY(40px)",
//             opacity: show ? 1 : 0,
//             transition: "all 1s ease",
//             width: "100%",
//             maxWidth: "600px",
//         },
//         logoBox: { 
//             marginBottom: isMobile ? "15px" : "25px" 
//         },
//         logoImg: {
//             width: isMobile ? "55px" : "70px",
//             filter: "drop-shadow(0px 0px 5px rgba(255,255,255,0.2))",
//         },
//         ultraText: {
//             color: "#6ec1e4",
//             letterSpacing: isMobile ? "2px" : "4px",
//             fontSize: isMobile ? "14px" : "18px",
//             marginBottom: "10px",
//             fontWeight: "500",
//         },
//         mainHeading: {
//             fontSize: isMobile ? "55px" : "90px",
//             fontWeight: "900",
//             letterSpacing: isMobile ? "3px" : "6px",
//             position: "relative",
//             display: "inline-block",
//             lineHeight: 1,
//             marginBottom: "15px",
//             background: `linear-gradient(to bottom, #f5f5f5 0%, #dcdcdc 20%, #bfbfbf 40%, #f0f0f0 50%, #9e9e9e 70%, #e6e6e6 85%, #cfcfcf 100%)`,
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//             textShadow: "0px 1px 0px rgba(255,255,255,0.4), 0px 3px 6px rgba(0,0,0,0.6)",
//         },
//         headingTexture: {
//             position: "absolute",
//             inset: 0,
//             background: "url('https://www.transparenttextures.com/patterns/asfalt-dark.png')",
//             opacity: 0.25,
//             mixBlendMode: "overlay",
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//             pointerEvents: "none",
//         },
//         premiumText: {
//             color: "#6ec1e4",
//             fontSize: isMobile ? "16px" : "20px",
//             letterSpacing: isMobile ? "2px" : "3px",
//             marginBottom: "10px",
//             fontWeight: "600",
//         },
//         subtext: {
//             color: "#cfd8dc",
//             fontSize: isMobile ? "12px" : "14px",
//             letterSpacing: "2px",
//             marginBottom: isMobile ? "20px" : "30px",
//         },
//         ecgBox: {
//             width: isMobile ? "240px" : "320px",
//             height: "60px",
//             margin: "auto",
//         }
//     };

//     return (
//         <div id="purity" style={styles.wrapper}>
//             <div style={styles.bgTexture} />

//             <div style={styles.container}>
//                 <div style={styles.logoBox}>
//                     <img src={a17logo} alt="A17 Logo" style={styles.logoImg} />
//                 </div>

//                 <div style={styles.ultraText}>ULTRA-PURIFIED</div>

//                 <div style={styles.mainHeading}>
//                     A17
//                     <span style={styles.headingTexture}>A17</span>
//                 </div>

//                 <div style={styles.premiumText}>PREMIUM HYDRO CELL</div>
//                 <div style={styles.subtext}>MOLECULARLY FILTERED WATER</div>

//                 <style>
//                     {`@keyframes drawLine { to { stroke-dashoffset: 0; } }`}
//                 </style>
//                 <div style={styles.ecgBox}>
//                     <svg viewBox="0 0 300 60" style={{ width: "100%", height: "100%" }}>
//                         <path
//                             d="M0 30 L100 30 L115 10 L130 50 L145 30 L300 30"
//                             stroke="#6ec1e4"
//                             strokeWidth="2"
//                             fill="none"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             style={{
//                                 strokeDasharray: "400",
//                                 strokeDashoffset: "400",
//                                 animation: "drawLine 2s ease forwards",
//                             }}
//                         />
//                     </svg>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default LabelDesign;



import React, { useEffect, useState } from "react";
import a17logo from "./A17 ULTRA-PURIFIED.png";

const LabelDesign = ({ isMobile }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      id="purity"
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#2c3437",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Montserrat', sans-serif",
        color: "white",
        position: "relative",
        overflow: "hidden",
        padding: "40px 20px",
        boxSizing: "border-box",
      }}
    >
      {/* Dynamic Keyframe Injection */}
      <style>{`
        @keyframes drawLine {
          to { stroke-dashoffset: 0; }
        }
      `}</style>

      {/* Background Cartographer Texture Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "#2c3437",
          backgroundImage: "url('https://www.transparenttextures.com/patterns/cartographer.png')",
          backgroundRepeat: "repeat",
          backgroundBlendMode: "multiply",
          zIndex: 1,
        }}
      />

      {/* Hero Content Container */}
      <div
        style={{
          textAlign: "center",
          zIndex: 2,
          transform: show ? "translateY(0)" : "translateY(40px)",
          opacity: show ? 1 : 0,
          transition: "transform 1s cubic-bezier(0.16, 1, 0.3, 1), opacity 1s ease",
          width: "100%",
          maxWidth: "600px",
        }}
      >
        {/* Brand Logo Container */}
        <div style={{ marginBottom: isMobile ? "15px" : "25px" }}>
          <img
            src={a17logo}
            alt="A17 Logo"
            style={{
              width: isMobile ? "55px" : "70px",
              filter: "drop-shadow(0px 0px 5px rgba(255,255,255,0.2))",
            }}
          />
        </div>

        <div
          style={{
            color: "#6ec1e4",
            letterSpacing: isMobile ? "2px" : "4px",
            fontSize: isMobile ? "14px" : "18px",
            marginBottom: "10px",
            fontWeight: "500",
          }}
        >
          ULTRA-PURIFIED
        </div>

        {/* Metallic Gradient Heading */}
        <h1
          style={{
            fontSize: isMobile ? "55px" : "90px",
            fontWeight: "900",
            letterSpacing: isMobile ? "3px" : "6px",
            lineHeight: 1,
            margin: "0 0 15px 0",
            background: "linear-gradient(to bottom, #f5f5f5 0%, #dcdcdc 20%, #bfbfbf 40%, #f0f0f0 50%, #9e9e9e 70%, #e6e6e6 85%, #cfcfcf 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            filter: "drop-shadow(0px 3px 6px rgba(0,0,0,0.6))",
          }}
        >
          A17
        </h1>

        <div
          style={{
            color: "#6ec1e4",
            fontSize: isMobile ? "16px" : "20px",
            letterSpacing: isMobile ? "2px" : "3px",
            marginBottom: "10px",
            fontWeight: "600",
          }}
        >
          PREMIUM HYDRO CELL
        </div>

        <div
          style={{
            color: "#cfd8dc",
            fontSize: isMobile ? "12px" : "14px",
            letterSpacing: "2px",
            marginBottom: isMobile ? "20px" : "30px",
          }}
        >
          MOLECULARLY FILTERED WATER
        </div>

        {/* ECG Line Animation */}
        <div
          style={{
            width: isMobile ? "240px" : "320px",
            height: "60px",
            margin: "0 auto",
          }}
        >
          <svg viewBox="0 0 300 60" style={{ width: "100%", height: "100%" }}>
            <path
              d="M0 30 L100 30 L115 10 L130 50 L145 30 L300 30"
              stroke="#6ec1e4"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{
                strokeDasharray: "400",
                strokeDashoffset: "400",
                animation: "drawLine 2s ease forwards",
              }}
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default LabelDesign;